import styled from 'styled-components';
import bannerImage from 'assets/images/accounting/finance-control.jpg';
import mediaQuery from 'styles/mediaQuery';

export const BuiltInBanner = styled.section`
  display: flex;
  align-items: center;
  min-height: 645px;
  padding: 96px ${({ theme }) => theme.spaces.padding.lg};
  background-image: ${({ theme }) =>
    `linear-gradient(90deg, ${theme.raw.system.blue.surface.hover} 4%, ${theme.raw.system.blue.surface.hover}cc 49%, rgba(160, 172, 224, 0.3) 100%), url(${bannerImage})`};
  background-size: cover;
  background-position: center;
  color: ${({ theme }) => theme.system.neutral.text.inverted};

  ${mediaQuery.xs} {
    min-height: 0;
    padding: ${({ theme }) => theme.spaces.padding.xxl}
      ${({ theme }) => theme.spaces.padding.lg};
  }
`;

export const BannerCopy = styled.div`
  max-width: 455px;
`;
